import React from 'react';
import ButtonBase from './ButtonBase';
import buttonPropTypes, { textAndA11yText } from './propTypes';
import { useThemeTokensCallback, useResponsiveThemeTokensCallback, useTheme } from '../ThemeProvider';
import { a11yProps } from '../utils/props';
import { useViewport } from '../ViewportProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    accessibilityRole = 'button',
    tokens,
    variant,
    ...props
  } = _ref;
  const viewport = useViewport();
  const {
    themeOptions: {
      enableMediaQueryStyleSheet
    }
  } = useTheme();
  const buttonVariant = enableMediaQueryStyleSheet ? variant : {
    viewport,
    ...variant
  };
  const useTokens = enableMediaQueryStyleSheet ? useResponsiveThemeTokensCallback : useThemeTokensCallback;
  const getTokens = useTokens('Button', tokens, buttonVariant);
  return /*#__PURE__*/_jsx(ButtonBase, {
    ...props,
    tokens: getTokens,
    accessibilityRole: accessibilityRole,
    ref: ref,
    viewport: viewport
  });
});
Button.displayName = 'Button';
Button.propTypes = {
  ...a11yProps.types,
  ...buttonPropTypes,
  children: textAndA11yText
};
export default Button;